import React from "react";
import AutocompleteItem from "theme/components/organisms/Autocomplete/AutocompleteItem/AutocompleteItem";
import { LinkButton } from "theme/components/atoms/Button";

const QueryResultItem = ({ result, onClick }) => {
  return (
    <AutocompleteItem
      name={<LinkButton onClick={onClick}>{result.query}</LinkButton>}
    />
  );
};

export default QueryResultItem;
